document.addEventListener('DOMContentLoaded', function() {
  const lazyVideos = document.querySelectorAll('[data-lazy-video]');

  // Use Intersection Observer with performance optimizations
  const videoObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;
        const source = video.querySelector('source');

        if (source && source.dataset.src) {
          // Use requestIdleCallback for non-critical loading
          if ('requestIdleCallback' in window) {
            requestIdleCallback(() => {
              source.src = source.dataset.src;
              video.load();
              video.play().catch(e => console.log('Video autoplay failed:', e));
            });
          } else {
            // Fallback for browsers that don't support requestIdleCallback
            setTimeout(() => {
              source.src = source.dataset.src;
              video.load();
              video.play().catch(e => console.log('Video autoplay failed:', e));
            }, 1);
          }

          observer.unobserve(video);
        }
      }
    });
  }, {
    rootMargin: '50px 0px',
    threshold: 0.1
  });

  lazyVideos.forEach(video => videoObserver.observe(video));
});
